import {useEffect} from 'react';
import './AddOffer.css';
import '../SingleOffer/SingleOffer.css';
import '../AddOfferInfo/AddOfferInfo.css'
import Roles from '../../data/MainCategory';
import Specialities from '../../data/SubCategories';
import { getAuth } from "firebase/auth";
import { useHistory } from 'react-router-dom';
import ShowEditFields from './EditFields/ShowEditFields';
import { useAtom } from 'jotai';
import { useAwaitOffer, useLoggedUser, useStepper, useChoosedOption, useShowPopUpModal } from '../../data/GlobalStates';

const AddOffer = ({checkUser, SelectedRole, setSelectedRole, Description, setCheckUser, setRefresh, refresh, setDescription, MaxSalaryWarn}) => {

  const authedUser = getAuth();
  const history = useHistory();

  //stany globalne:
  const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
  const [ Stepper, setStepper ] = useAtom(useStepper);
  const [ ChoosedOption, setChoosedOption ] = useAtom(useChoosedOption);
  const [ ShowPopUpModal, setShowPopUpModal ] = useAtom(useShowPopUpModal);
  const [ AwaitOffer, setAwaitOffer ] = useAtom(useAwaitOffer); 

  useEffect(()=>{
    if (!authedUser.currentUser && !LoggedUser ) {
      history.push('/userPanel')
      };
  },[LoggedUser, authedUser.currentUser]);


  useEffect(()=>{
    if (Stepper === 0) {
      setAwaitOffer({})
    }
  },[Stepper]);


const CloseModalByKey = (e) => {
  if (e.key === 'Enter') {
    setShowPopUpModal(false)
  }
};


const stepBack = (step, option) => {
  setCheckUser(checkUser - 1)
  setStepper(step)
  setChoosedOption(option)
  window.scrollTo(0, 0)
}

    return (
     <div id='AddOfferMainDiv' onKeyDown={(e) => CloseModalByKey(e)} tabIndex={1} >
      { Stepper === 1 ? 
            <>
             <ShowEditFields
               SelectedRole={SelectedRole}
               setSelectedRole={setSelectedRole}
               Roles={Roles}
               Specialities={Specialities}
               refresh={refresh}
               Description={Description}
               setDescription={setDescription}
               MaxSalaryWarn={MaxSalaryWarn}
               stepBack={stepBack}
               setRefresh={setRefresh}
             />
             </> : '' }
    </div>
    )
}

export default AddOffer;
